export const EDITOR_PLUGINS = [
  "lists",
  "advlist",
  "autolink",
  "link",
  "charmap",
  "preview",
  "anchor",
  "searchreplace",
  "visualblocks",
  "code",
  "fullscreen",
  "insertdatetime",
  "table",
  "help",
  "wordcount",
  "textcolor",
  "font",
  "color"
];

export const TOOLBAR_ITEMS = [
  "bullist",
  "bold",
  "fontsize",
  "forecolor",
  "outdent",
  "indent",
  "hr",
  "italic",
  "strikethrough",
  "underline",
  "backcolor",
  "removeformat"
];

export const FONT_SIZES = [
  "8pt",
  "10pt",
  "12pt",
  "14pt",
  "18pt",
  "24pt",
  "36pt"
];

export const getEditorConfig = (onBlurCallback) => ({
  menubar: false,
  toolbar_mode: "floating",
  plugins: EDITOR_PLUGINS,
  toolbar: TOOLBAR_ITEMS.join(" "),
  fontsize_formats: FONT_SIZES.join(" "),
  advlist_bullet_styles: "disc",
  min_height: 200,
  content_style: "body { max-height: 600px; overflow-y: auto; }",
  setup: (editor) => {
    editor.on("blur", () => {
      const content = editor.getContent();
      onBlurCallback(content);
    });
  }
});
